import css from "./Price.module.css";
import React, { useState } from "react";
import { Button, Col, Row } from "reactstrap";
import { useStore } from "store";
import { numberWithCommas } from "utils";
import { useTranslation } from "react-i18next";
import QuoteModal from "./QuoteModal";

/**
 * - rotation pricing (full, pole)
 * - size pricing (x,y,z size)
 * - theme (user content, custom pricing for each)
 * - table (user content, custom pricing for each)
 * - ring (user content, custom pricing for each, should be 4 types)
 * - control (manual, app)
 * - 230V power supply (true/false)
 */
function Price({ data }) {
	const { i18n } = useTranslation()
	const t = useStore(state => state.translations)
    const rotationId = useStore(state => state.rotation)
	const sizeId = useStore(state => state.size)
	const themeId = useStore(state => state.theme)
	const tableId = useStore(state => state.table)
	const ringId = useStore(state => state.ring)
	const controlId = useStore(state => state.control)
    const powerSupply = useStore(state => state.powerSupply)

	const [isModalOpen, setModal] = useState(false);

	const rotation = (data.rotations && data.rotations[rotationId] && data.rotations[rotationId].price) || 0
	const size = (data.sizes && data.sizes[sizeId] && data.sizes[sizeId].price) || 0
	const theme = (data.themes && data.themes[themeId] && data.themes[themeId].price) || 0
	const table = (data.tables && data.tables[tableId] && data.tables[tableId].price) || 0
	const ring = (data.rings && data.rings[ringId] && data.rings[ringId].price) || 0
	const control = (data.addons && data.addons.control && data.addons.control[controlId] && data.addons.control[controlId].price) || 0
    const power = (powerSupply && data.addons && data.addons.powerSupply && data.addons.powerSupply.price) ? data.addons.powerSupply.price : 0
    
    const basePrice = data.basePrice || 0
    // Final price, adding everything together
    const price = basePrice + rotation + size + theme + table + ring + control + power

	function handleModal() {
		setModal(!isModalOpen)
	}

	return (
		<div className="mt-5">
			<Row>
				<Col className={css.priceCol}>
					<img src={process.env.PUBLIC_URL + "/img/dots.png"} className={css.dots} alt ="Dots" />
					<p className={css.priceLabel}>{t.quote.price[i18n.language]}</p>
					<p className={css.priceValue}>{numberWithCommas(Number(price).toFixed(2))}€</p>
					<p className={css.priceDesc}>{t.quote.desc[i18n.language]}</p>
				</Col>
				<Col>
					<Button outline onClick={handleModal} className={css.button} disabled={!sizeId}>{t.quote.qetAQuote[i18n.language]}</Button>
				</Col>
			</Row>
			<QuoteModal isOpen={isModalOpen} data={data} handleModal={handleModal} />
		</div>
	);
}

export default Price;
